import { render, staticRenderFns } from "./ProcessForDownload.vue?vue&type=template&id=20bd738b"
import script from "./ProcessForDownload.vue?vue&type=script&lang=js"
export * from "./ProcessForDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports